import { render, staticRenderFns } from "./applicant-link-requests.vue?vue&type=template&id=c68fc122&scoped=true"
import script from "./applicant-link-requests.vue?vue&type=script&lang=js"
export * from "./applicant-link-requests.vue?vue&type=script&lang=js"
import style0 from "./applicant-link-requests.vue?vue&type=style&index=0&id=c68fc122&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c68fc122",
  null
  
)

export default component.exports